module.exports = __webpack_public_path__ + "img/warm.8eafa7c7.jpg";